// extracted by mini-css-extract-plugin
export default {"truncatedText":"DecisionDetails__truncatedText___35C0s"};